module.exports = __webpack_public_path__ + "static/media/InvertedSlider.abf0e382.mp4";